import { Component, Input, inject } from '@angular/core';
import { NavOverflowExtendedData } from '../../interfaces/nav-overflow-extended-data.interface';
import { ContentUtil } from '../../utils/content/content.util';
import { NavOverflowModule } from '@vg-constellation/angular-20/nav-overflow';
import { NgIf } from '@angular/common';

const ACTIONS = 'Actions';

export interface ActionNavOverflowMenuComponentProps {
    navOverflowMenuConfig: NavOverflowExtendedData;
}
@Component({
    selector: 'zci-action-nav-overflow-menu',
    templateUrl: './action-nav-overflow-menu.component.html',
    imports: [
        NgIf,
        NavOverflowModule,
    ],
})
export class ActionNavOverflowMenuComponent implements ActionNavOverflowMenuComponentProps {
    @Input() navOverflowMenuConfig: NavOverflowExtendedData;
    content = ContentUtil.content;
        
   get isVisible():boolean{
        return this.navOverflowMenuConfig?.label !== ACTIONS;
   }
}
